import {addDays, differenceInDays, format} from 'date-fns'
import Api from '../../api/api'
import Socket from '../../api/socket'
import {PROGRAMS_URL} from '../../api/routes';

const DATE_FORMAT = 'yyyy-MM-dd';

let programChangeSubscription = null;

export default {
  namespaced: true,
  state: {
    isLoading: false,
    program: false, // the current program
    broadcasts: [], // the list of broadcasts
    broadcastsDate: new Date(),
  },
  getters: {
    headerImage: ({program}) => (type) => {
      if (!program) {
        return
      }
      for (const image of program.headerImages) {
        if (image[type])
          return image[type]
      }
    },
    broadcastsWithoutNonstop: (state) => {
      return state.broadcasts.filter((broadcast) => broadcast.presenters.length > 0)
    },
    currentBroadcast: (state) => {
      const now = new Date()
      return state.broadcasts.find((broadcast) => broadcast.startsAt < now && broadcast.stopsAt >= now)
    }
  },
  actions: {
    subscribeOnChange({commit, rootState, dispatch}) {
      const station = rootState.stations.stationId;
      if (programChangeSubscription) {
        programChangeSubscription.unsubscribe();
      }
      programChangeSubscription = Socket.subscribe('program', 'change', (data, envelope) => {
        data.stationId = envelope.station;
        commit('PROGRAM_CHANGE', data);
        dispatch('setTheme');
      }, {backlog: 1, station})
    },
    async fetch({state, commit}, date) {
      if (!date) {
        return;
      }
      const from = format(date, DATE_FORMAT);
      const to = format(addDays(date, 1), DATE_FORMAT);
      if (state.isLoading) {
        return;
      }
      commit('LOAD_START');
      try {
        const response = await Api.get(`/2.0/broadcasts?begin=${from}&end=${to}`);
        const {data: {broadcasts}} = response;
        const newBroadcasts = broadcasts
          .map(broadcast => {
            const headerImages = broadcast.header_images.reduce((agg, item) => {
              Object.entries(item).forEach(([key, value]) => {
                agg[key] = value
              })

              return agg
            }, {});

            return {
              id: broadcast.id,
              title: broadcast.title,
              presenters: broadcast.presenters.map(presenter => presenter.name),
              start: broadcast.start,
              stop: broadcast.stop,
              startsAt: new Date(broadcast.start),
              stopsAt: new Date(broadcast.stop),
              nowOnAirInfo: broadcast.now_on_air_info,
              humanScheduleCopy: broadcast.human_schedule_copy,
              url: `${PROGRAMS_URL}/${broadcast.program_slug}`,
              headerImages,
            };
          });

        commit('BROADCASTS_FETCHED', {broadcasts: newBroadcasts, broadcastsDate: date});
      } catch (error) {
        console.log(error); // eslint-disable-line
        commit('LOAD_FAIL');
      }
    },
    fetchNext({state, dispatch}) {
      const date = state.broadcastsDate;
      const newDate = addDays(date, 1)
      // Only display 7 days into the future
      if (differenceInDays(newDate, new Date()) < 7) {
        dispatch('fetch', newDate);
      }
    },
    fetchPrevious({state, dispatch}) {
      const date = state.broadcastsDate;
      dispatch('fetch', addDays(date, -1));
    },
    fetchToday({dispatch}) {
      dispatch('fetch', new Date());
    },
    setTheme({state}) {
      const newTheme = state.program.theme;
      const body = document.body;
      if (!newTheme || body.classList.contains(newTheme)) {
        return;
      }

      body.className.split(' ').forEach(cls => {
        const isThemeClass = cls.match(/^(q|joe)[-_]/);
        if (isThemeClass && cls !== newTheme) {
          body.classList.remove(cls);
        }
      });
      body.classList.add(newTheme);
    }
  },
  mutations: {
    PROGRAM_CHANGE(state, program) {
      const {
        header_images,
        title,
        human_schedule_copy: schedule,
        description,
        id,
        start,
        stop,
        program_id: programId,
        theme,
        shout,
        program_slug: slug,
        presenters
      } = program;
      const homepageImageObj = header_images.find(item => item.homepage_header)
      const programCurrentImageObj = header_images.find(item => item.program_current_tile)
      const homepageImage = homepageImageObj && homepageImageObj.homepage_header
      const programCurrentImage = programCurrentImageObj && programCurrentImageObj.program_current_tile

      const presenterNames = presenters.map(presenter => presenter.name)

      state.program = {
        id,
        title,
        schedule,
        homepageImage,
        programCurrentImage,
        description,
        programId,
        presenterNames,
        start,
        stop,
        shout,
        slug,
        theme,
        headerImages: header_images
      };
    },
    BROADCASTS_FETCHED(state, {broadcasts, broadcastsDate}) {
      state.broadcasts = broadcasts;
      state.broadcastsDate = broadcastsDate;
      state.isLoading = false;
    },
    LOAD_START(state) {
      state.isLoading = true;
    },
    LOAD_FAIL(state) {
      state.isLoading = false;
    },
  }
}
